<template>
	<scoped-overflow-layout :loading="isFindPending || isSearchPending">
		<template #toolbar>
			<v-toolbar flat dense color="white">
				<v-tooltip bottom>
					<template #activator="data">
						<v-btn small icon v-on="data.on" @click="setViewGrid">
							<v-icon :color="toolbarIconColor" :size="toolbarIconSize">mdi-grid</v-icon>
						</v-btn>
					</template>
					<span>{{ $t('GENERAL_TOOLBAR_VIEW_GRID_HINT') }}</span>
				</v-tooltip>
				<v-tooltip bottom>
					<template #activator="data">
						<v-btn small icon v-on="data.on" @click="setViewTable">
							<v-icon :color="toolbarIconColor" :size="toolbarIconSize">mdi-format-list-bulleted</v-icon>
						</v-btn>
					</template>
					<span>{{ $t('GENERAL_TOOLBAR_VIEW_LIST_HINT') }}</span>
				</v-tooltip>
				
				<v-spacer />

				<bar-pagination v-if="!!actions.length" :page="page" :count="count" :total="actions.length" @previous="prevPage" @next="nextPage" />
			</v-toolbar>
		</template>

		<v-layout v-if="!currentPage.length" class="pa-4" justify-center>{{ $t('ACTION_NO_DATA_TEXT') }}</v-layout>
		<action-grid v-else-if="view === 'Grid'" :actions="currentPage"></action-grid>
		<action-list v-else                      :actions="currentPage"></action-list>
		
	</scoped-overflow-layout>
</template>


<script>
import { mapState, mapGetters } from 'vuex';
import { ViewType } from '@/store/constants';

import ScopedOverflowLayout from "@/layouts/ScopedOverflowLayout.vue";
import BarPagination from "@/components/BarPagination.vue";
import ActionGrid from "@/components/ActionGrid.vue";
import ActionList from "@/components/ActionList.vue";

export default {
	name: "home",
	components: { ScopedOverflowLayout, BarPagination, ActionGrid, ActionList },
	data() { return {
		count: 20,
		page: 0,
	}},
	computed: {
		...mapState(['toolbarIconColor', 'toolbarIconSize']),
		...mapGetters(['view']),
		...mapState('actions', ['isFindPending','filter']),
		...mapState('actions', {
			'isSearchPending': 'isFindPending'
		}),
		...mapGetters('actions', {
			actions: 'filtered',
		}),
		pageRange() {
			const min = this.count * this.page;
			const max = Math.min(min + this.count, this.actions.length);
			return { min, max };
		},
		currentPage() {
			return this.actions.slice(this.pageRange.min, this.pageRange.max);
		},
	},
	watch: {
		filter(newFilter, oldFilter) {
			// reset page when filter has changed
			if (oldFilter.type !== newFilter.type || oldFilter.value !== newFilter.value) {
				this.page = 0;
			}
		}
	},
	methods: {
		setViewGrid() {
			this.$store.dispatch('setView', ViewType.Grid);
		},
		setViewTable() {
			this.$store.dispatch('setView', ViewType.Table);
		},
		prevPage() {
			--this.page;
		},
		nextPage() {
			++this.page;
		},
	},
	mounted() {
		this.$store.commit('actions/clearCurrent');
	},
};
</script>
